import React from "react";
import useDialogLauncher from "@hooks/@lore/dialogs-routable/_hooks/useDialogLauncher";
import {DialogManager} from "@/dialogs_new/DialogManager";

export default function SiteListItem({site}) {
  const launch = useDialogLauncher();

  function onClick(e) {
    e.preventDefault();
    launch(DialogManager.SiteManage.Config(site.id));
  }

  return (
    <li className="flex items-start justify-between gap-4">
      <div className="min-w-0 w-full">
        <button
          onClick={onClick}
          className="hover:underline cursor-pointer text-left w-full"
          title={site.name}
        >
          <div className="truncate">{site.name}</div>
        </button>
      </div>
    </li>
  );
}
